function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgurMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 19627",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 4311",
    width: 34,
    height: 34,
    rx: 6,
    style: {
      fill: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "paragraph (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16298",
    d: "M3.353 4.5h15.336a1.353 1.353 0 0 1 0 2.706H3.353a1.353 1.353 0 1 1 0-2.706z",
    transform: "translate(5.979 5.734)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16299",
    d: "M3.353 10.5h12.779a1.353 1.353 0 0 1 0 2.706H3.353a1.353 1.353 0 1 1 0-2.706z",
    transform: "translate(8.535 5.146)",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16300",
    d: "M3.353 16.5h7.668a1.353 1.353 0 1 1 0 2.706H3.353a1.353 1.353 0 0 1 0-2.706z",
    transform: "translate(13.647 4.559)",
    style: {
      fill: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgurMenu);
export default __webpack_public_path__ + "static/media/burgur-menu.768b615be0f21fdf9d2a889dca2517c9.svg";
export { ForwardRef as ReactComponent };